import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible/flexible';
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: "https://static.cjlcar.com/xyx/website/error.png",
    loading: "https://static.cjlcar.com/xyx/website/loading.gif",
    attempt: 1
});

new Vue({
    render: h => h(App),
}).$mount('#app')